var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUser = function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.974 14.727a7 7 0 1 1 8.053 0 11.5 11.5 0 0 1 5.933 5.023 1 1 0 1 1-1.732 1 9.5 9.5 0 0 0-16.456 0 1 1 0 0 1-1.732-1 11.5 11.5 0 0 1 5.934-5.023M7 9a5 5 0 1 1 10 0A5 5 0 0 1 7 9",
    clipRule: "evenodd"
  })));
};
export default SvgIconUser;